import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../shared/services/apiService.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RootService } from 'src/app/shared/services/root.service';
import { environment } from '../../environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonService } from '../shared/services/common.service';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { ThankuResponse } from '../shared/payload-Model/billingFormModel';
const url = 'assets/product-lead-script.js';
import * as unbxUrl from '../../assets/unbx-script';
import { Meta } from '@angular/platform-browser';
function _window(): any {
  // return the global native browser window object
  // if (isPlatformBrowser(this.platformId)) {
    return window;
  // }
}
@Component({
  selector: 'app-product-lead',
  templateUrl: './product-lead.component.html',
  styleUrls: ['./product-lead.component.scss']
})
export class ProductLeadComponent implements OnInit {
  environment1 = environment.s3bucket.url;
  productDetailList: any;
  productLoaded: boolean = false
  sub: Subscription = new Subscription();
  id: any;
  totalAmount: any;
  bookingForm!: FormGroup;
  isSubmitForm: boolean = false;
  stateList: any[];
  districtList: any[];
  dealerList: any = [];
  showotp: boolean = false;
  disableMainFields: boolean = false;
  divData: any;
  statedata: any[];
  disabledFields: boolean = false;
  response: any;
  showCongratulationMsg: boolean = false;
  tractionSuccess: boolean;
  tractionfailed: boolean = false;
  bannerImg: string;
  defaultbannerImg: string;
  reqID: any;
  Payresponse: any
  leadData: any;
  userData: any;

  errormsg: any;
  m: any;
  s: any;
  timeLeft: any;
  isTimer: boolean = false;
  isLoading: any = false;
  bannerList: any;
  payMessage: string = "";
  imageUrl: string = "";

  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 1200,
    autoplay: true,
    // nav: true,
    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },

  }
  loadAPI: Promise<any>;
  hideproceedbtn: boolean = false;
  pagetitle = "Lead Booking";
  utm_source: any;
  utm_medium: any;
  utm_campaign: any;
  gclid: any;
  newVCPrice: any;
  encData: string;
  orderID: any;
  LeadDetailList: any;
  ccavenue: any;
  isDisabled: boolean=false;
  isSubmitted: boolean = false;
  dealerCode: string;
  constructor(private activatedRoute: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService, private regexService: RegexService
    , private toastrService: ToastrService,
    private storageService: RootService, private spinner: NgxSpinnerService,
    private cleverService: ClevertapService,
    private formBuilder: FormBuilder, private formErrorService: FormErrorService,
    private CommonService: CommonService,
    private localStorage: secureStorage, private router: Router,private meta: Meta

  ) {
    this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    this.loadAPI = new Promise((resolve) => {
      this.regexService.loadScript();
      resolve(true);
    });
  }




  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView(this.pagetitle);
      } catch { }
    
    if (localStorage.getItem("dealercd")) {
      this.isDisabled=true;
    }

  }


    if (this.router.url.includes('payment_type=cc_avenue')) {
      this.activatedRoute.queryParams.subscribe(params => {
        if (isPlatformBrowser(this.platformId)) {
        this.Payresponse = JSON.parse(this.localStorage.getItem('Payresponse'));
        }
        //  let order_id = params["order_id"];
        let success = params["success"];

        this.id = this.Payresponse.vehicleID
        this.isLoading = true;
        this.defaultbannerImg = environment.s3bucket.url + 'ProductLead/' + 1520 + ".jpg";
        this.bannerImg = environment.s3bucket.url + 'ProductLead/' + this.id + ".jpg";
        this.bannerList = [{
          "image": this.defaultbannerImg
        }]
        this.isLoading = true
        this.getVehicleDetail();
        if (success == "true") {
          this.showCongratulationMsg = true;
          this.tractionSuccess = true;
          // let Message =  this.Payresponse?.payMessage+
          // " received against Request ID " +
          // this.Payresponse?.reqId +
          // ".";
          this.reqID = this.Payresponse?.reqId;
          if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem("accessTokenSILead")
          }

        } else {
          this.showCongratulationMsg = true;

          this.tractionfailed = true;
          let Message = this.Payresponse?.payMessage +
            " is not received against Request ID " +
            this.Payresponse?.reqId +
            "."; this.Payresponse.headMessage = "Sorry !";
          let HeadMessage = "Sorry !";
          const ResponseDatas: PaymentResponse = {} as PaymentResponse;
          ResponseDatas.razorpay_order_id = this.Payresponse?.orderId;
          this.errormsg = {
            head: HeadMessage,
            desc: Message
          }
          if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem("accessTokenSILead")
          }

        }
      });
    } else {
      this.activatedRoute.paramMap.subscribe(params => {


        this.id = params.get('id')
        this.encData = params.get('reqid');
        this.orderID = params.get('orderID');




        if (params.get('id')) {
          this.isLoading = true;
          this.defaultbannerImg = environment.s3bucket.url + 'ProductLead/' + 1520 + ".jpg";
          this.bannerImg = environment.s3bucket.url + 'ProductLead/' + this.id + ".jpg";
          this.bannerList = [{
            "image": this.defaultbannerImg
          }]
          this.isLoading = true
          this.getVehicleDetail();

          this.booking();
        }
      });
    }


    this.campaign()
    this.getDealerDetail();
    this.getEncryptionccavenue();

  }


  public loadScript() {
    if (isPlatformBrowser(this.platformId)) {
      let node = document.createElement('script');
      node.src = url;
      node.type = 'text/javascript';
      node.async = true;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);

      var noscript = document.createElement('noscript')
      var iframe = document.createElement('img')
      iframe.setAttribute('src', "https://www.facebook.com/tr?id=848798723707544&ev=PageView&noscript=1")
      iframe.setAttribute("height", "1")
      iframe.setAttribute("width", "1")
      iframe.setAttribute("style", "display:none;")
      noscript.appendChild(iframe)
      document.body.appendChild(noscript)
    }
  }
  getcodeCT(eventName) {
    if (isPlatformBrowser(this.platformId)) {

      this.cleverService.GetCodeClicked(
        eventName,
        this.bookingForm.value.mobile,
        this.id, this.productDetailList?.model,
        window.location.href)
    }
  }

  getQuantity() {

    if (this.bookingForm.value.quantity == "0") {
      this.bookingForm.patchValue({
        quantity: "1",
      });
    }
  }
  getVehicleDetail() {
    let data;
    data = {
      product_id: this.id
    }
    this.sub.add(this.apiService.getVehicleDetails(data).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.productDetailList = res?.data;
          this.imageUrl = this.productDetailList?.images[0]?.image_url

          this.getStateList(this.productDetailList.lob);
          this.totalAmount = this.productDetailList?.down_payment
          this.productLoaded = true
          if (isPlatformBrowser(this.platformId)) {

            this.cleverService.LandingPageViewed(
              this.id, this.productDetailList?.model,
              this.productDetailList?.images[0]?.image_url,
              this.productDetailList['sub_lob'],
              this.productDetailList['lob'],
              this.productDetailList['ppl'],
              window.location.href,
              this.productDetailList['price_range'],
              this.productDetailList['down_payment'])

          }
        }
      },
      error: () => {
        this.productLoaded = true;
        this.toastrService.success('Not Found');
      },
      complete: () => {
        this.getLeadDetail();

      }
    }))
  }

  booking(item?) {


    this.bookingForm = this.formBuilder.group({
      first_name: [item?.user?.first_name, [Validators.required,]],
      last_name: [item?.user?.last_name],
      state: [item ? item?.leads[0]?.state_code : "", [Validators.required]],
      district: [item ? item?.leads[0]?.district?.toLowerCase() : "", [Validators.required]],
      dealer: [item ? item?.leads[0]?.division_id : "", [Validators.required]],
      quantity: 1,
      // quantity: [item?.leads[0]?.quantity, [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(10)]],
      mobile: ["", [Validators.required, Validators.maxLength(10), Validators.pattern(this.regexService.Phone)]],
      otp: [""],

    });

    if (item) {

      let a = this.dealerList.filter(element => element.division_id == this.bookingForm.value.dealer


        // element.division_id == this.bookingForm.value.dealer

      );


      if (a?.[0]?.payment_details?.[0]?.payment_gt_type == "CCAVENUE") {

        this.getCcAvenueEncryptionKey(this.LeadDetailList, a?.[0]?.payment_details?.[0]?.account_id, this.leadData.product)
      }
      else if (a?.[0]?.payment_details?.[0]?.payment_gt_type == "RAZORPAY") {

        let orderDetails = {

          razorpay_account_id: this.leadData.razor_pay_detail[0].account_id,
          razorpay_access_key: this.leadData.razorpay_access_key,
          // razorpay_access_key: this.leadData.razor_pay_detail[0].access_key_id,
          order_id: this.orderID,
          pay_amount: this.leadData.product.down_payment,
          product_name: this.leadData.product.pl,
          product_description: this.leadData.product.vehicle_number,
          shopping_order_id: this.leadData.row_id,
          email: this.userData.email_id,
          contact: this.userData.mobile_number,
        };
        this.payMessage = "Request In Process";
        // this.isVerifyOtp = true;
        this.payWithRazor(orderDetails, this.leadData, this.leadData.product);
      }
      else {
        this.toastrService.warning("We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.");

      }


    }

  }
  getVCPrice(data) {

    this.sub.add(this.apiService.getDealerPrice(data).subscribe({
      next: (response: any) => {
        this.newVCPrice = response?.data?.dealer_price ? response.data.dealer_price : null;

      },
      error: () => { },
      complete: () => { }
    }))
  }
  setDivision() {
    this.divData = this.dealerList.filter((division: any) => division.division_id == this.bookingForm.value.dealer);


    let priceData = {
      "dealer_code": this.divData[0]?.dealer_code,
      "vc_number": this.productDetailList["vehicle_number"] ? this.productDetailList["vehicle_number"] : ""
    }
    this.getVCPrice(priceData)
  }
  getStateList(lob: any) {
    this.stateList = [];

    lob = {
      lob: lob,
    };

    this.sub.add(this.apiService.getLocations(lob).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.stateList = response["data"];
          if(this.dealerCode && this.disableMainFields){
            if(this.stateList?.length>0){
              this.getDealerDistricList(this.dealerList?.[0]?.state_name, this.dealerList?.[0]?.state);
            }
          }
        }
      },
      error: () => {
      },
      complete: () => {

      }
    })
    );
  }

  getDealerDealerList() {
    let data: any
     data = {
      "dealer_code": this.dealerCode,
      "action_type": "dropdown"
    }
    this.disableMainFields = false;
    this.sub.add(this.apiService.getDealerList(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          let dealerData = response['data'];
          this.disableMainFields = true
        dealerData.forEach((e) => {
          const exists = this.dealerList.some(dealer => dealer?.division_name === e?.division_name);
          if (!exists) {
            this.dealerList.push({
              division_id: e.division_id,
              division_name: e.division_name,
              state_name: e.state_name,
              state: e.state
            });
          }
        });
        this.bookingForm.patchValue({state:this.dealerList?.[0].state})
        this.bookingForm.patchValue({ dealer: this.dealerList?.[0]?.division_id });
        }
        else {
          // this.toastrService.warning("Something went wrong!");
          this.disableMainFields = false
        }
      },
      error: (error) => {
        this.toastrService.warning(error.data.msg);

      },
      complete: () => {
      }
    })
    );
  }

  getDealerList(state?: any, state_cd?: any, district?: any) {
    this.resetForm('dealer');
    let ll;
    if (state && state_cd) {
      ll = {
        code: state_cd,
        state: state,
      };
    }
    else {
      let statedata: any = this.stateList.filter(
        (result) => result.code
          === this.bookingForm.value.state
      );

      ll = {
        code: statedata[0]?.code,
        state: statedata[0]?.name,
      };
    }
    let data: any

    data = {
      district: (state && state_cd) ? district : this.bookingForm.value.district,
      state: ll.code,
      vc: this.productDetailList.vehicle_number,
      lob_name: this.productDetailList.lob,
    };
    if(this.dealerCode && this.disableMainFields){
      data['dealer_code'] = this.dealerCode
    }
    this.sub.add(this.apiService.getDealerList(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.dealerList = response["data"];

        }
        if(this.dealerCode && this.disableMainFields){
          this.bookingForm.patchValue({ dealer: this.dealerList?.[0]?.division_id });
          this.setDivision();
        }
      },
      error: (error) => {
        this.toastrService.warning(error.data.msg);

      },
      complete: () => {
        if (this.encData) {
          this.booking(this.LeadDetailList);
        }
      }
    })
    );
  }


  signup() {
    if (this.bookingForm.status == 'INVALID') {
      this.formErrorService.displayFormErrors(this.bookingForm);

      return;
    }

    let data = {
      "first_name": this.CommonService.replaceUnicode(this.bookingForm.value.first_name),
      "last_name": this.CommonService.replaceUnicode(this.bookingForm.value.last_name),
      "mobile_number": this.bookingForm.value.mobile,
      "email_id": "",
      "state": this.bookingForm.value.state,
      "district": this.bookingForm.value.district
    }
    this.spinner.show();
    this.sub.add(this.apiService.userSignup(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          if (isPlatformBrowser(this.platformId)) {
            this.cleverService.CodeVerified(
              this.CommonService.replaceUnicode(data.first_name),
              this.CommonService.replaceUnicode(data.last_name),
              data.state,
              data.district,
              this.divData[0]?.division_id ? this.divData[0]?.division_id : "",
              String(this.bookingForm.value.quantity),
              data.mobile_number,
              this.id, this.productDetailList?.model, window.location.href);
            this.cleverService.onUserLogin(response.data.first_name + ' ' + response.data.last_name, response.data.email_id, response.data.mobile_number);

          }
          this.getCode('Get Code Clicked');
          this.spinner.hide();
        }
        else {
          this.toastrService.warning("Something went wrong!")
          this.spinner.hide();
        }
      },
      error: () => {
        this.toastrService.warning("Something went wrong!")
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      }
    }))
  }

  getDealerDistricList(stateName,stateCode) {
    this.statedata = this.stateList.filter(
        (result) => result.code
          === this.bookingForm.value.state
      );
    let data = {
      "state": { "code": stateCode, "state": stateName},
      "lob": this.productDetailList.lob,
      "dealer_code": this.dealerCode && this.disableMainFields ? this.dealerCode : ''
  }
    this.sub.add(this.apiService.getLocations(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.districtList = response["data"];
          this.bookingForm.patchValue({district:this.districtList?.[0]})
        }
        this.getDealerList(stateName, stateCode, this.districtList?.[0]);
      },
      error: () => {
      },
      complete: () => {

      }
    })
    );
  }

  async getDistrictList(state?: any, state_cd?: any) {
    this.dealerList = [];
    this.districtList = [];
    this.resetForm('district');
    this.resetForm('dealer');
    let ll;

    if (state && state_cd) {
      ll = {
        code: state_cd,
        state: state,
      };
    }
    else {
      this.statedata = this.stateList.filter(
        (result) => result.code
          === this.bookingForm.value.state
      );

      ll = {
        code: this.statedata[0].code,
        state: this.statedata[0].name,
      };
    }
    let stateData: any = {
      state: ll,
      lob: this.productDetailList.lob,
    };

    await this.sub.add(this.apiService.getLocations(stateData).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.districtList = response["data"];

        }
      },
      error: () => {
      },
      complete: () => {

      }
    })
    );

  }
  alphanumbericOnlyFirstLastName(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]|[.]|[ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  NumberKeyEvent(event: any) {
    var ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }
  // onFocusOutRemoveSpaceFirstName(event: any) {
  //   let value = (event.target.value).replace(/\s/g, "")
  //   this.bookingForm.patchValue({ first_name: value })
  // }
  onFocusOutRemoveSpace(event: any) {
    let value = (event.target.value).replace(/\s/g, "")
    this.bookingForm.patchValue({ last_name: value })
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  notAllowSpace(event: any) {
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
  }

  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign = await params['utm_campaign'] || await params['utm_campaignname'];
      this.gclid = await params['gclid'];
    })
  }

  getDealerDetail(){
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.dealerCode = await params['dealer'];
      if(this.dealerCode){
        this.getDealerDealerList();
      }
    })
  }

  getCode(evntName) {
    this.isSubmitted = true;
    this.getcodeCT(evntName)
    if (this.bookingForm.invalid) {

      const controls = this.bookingForm.controls;

      const firstInvalidRequiredControl = Object.keys(controls).find((key) => {
        const control = controls[key];
        return (
          control.hasValidator(Validators.required) &&
          control.invalid
        );
      });

      if (firstInvalidRequiredControl) {
        const invalidElement = document.getElementsByName(firstInvalidRequiredControl)[0]; // Use name attribute
        if (invalidElement) {
          invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          (invalidElement as HTMLElement).focus();
        }
      }
    }


    if (this.bookingForm.status === 'INVALID') {
      this.formErrorService.displayFormErrors(this.bookingForm);
      return;
    }
    // if (this.regexService.containsSpecialChars(this.bookingForm.value.last_name.trim() || this.bookingForm.value.first_name.trim())) {
    //   this.toastrService.warning('Special characters are not allowed');
    //   return
    // }
    this.spinner.show();
    let data = {
      mobile_number: this.bookingForm.value.mobile,
      action_type: 'login',
    };
    this.sub.add(
      this.apiService.sentOtp(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            //getcode ct event
            this.getcodeCT('Code Sent Successfully');
            this.startTimer(119);

            this.showotp = true;
            this.disabledFields = true;
            this.toastrService.success(response.data.msg);
            this.spinner.hide();

          } else {
            this.spinner.hide();
            if (response?.data?.msg == 'User is not registered.') {
              this.signup();

            } else {
              this.toastrService.warning('Something went wrong!');
              this.spinner.hide();
            }
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();

        },
      })
    );
  }


  async createLead() {

    this.spinner.show();
    let data = {
      "lead_type": "BOOKING",
      "mm_geography": this.divData?.[0]?.mm_geography ? this.divData?.[0]?.mm_geography : "",
      "division_id": this.divData?.[0]?.division_id ? this.divData?.[0]?.division_id : "",
      "lob": this.productDetailList?.lob ? this.productDetailList?.lob : "",
      "mobile_number": this.bookingForm.controls['mobile'].value,
      "email_id": "",
      "first_name": this.CommonService.replaceUnicode(this.bookingForm.controls['first_name'].value.trim()),
      "last_name": this.bookingForm.controls['last_name'].value ?
        this.CommonService.replaceUnicode(this.bookingForm.controls['last_name'].value.trim()) : '.',
      "address_one": "",
      "address_two": "",
      "state": this.statedata?.[0].name,
      "state_code": this.statedata?.[0].code,
      "district": this.bookingForm.value.district,
      // "organization_name":
      //   // this.productDetailList.lob == "HCV Cargo" || this.productDetailList.lob == "MCV Trucks" || this.productDetailList.lob == "HCV Const" || this.productDetailList.lob == "ICV Trucks"?
      //   this.CommonService.replaceUnicode(this.bookingForm.controls['first_name'].value.trim()) +
      //   this.CommonService.replaceUnicode(this.bookingForm.controls['last_name'].value.trim()) + this.bookingForm.controls['mobile'].value
      // : ""
      "organization_name":
      this.CommonService.replaceUnicode(this.bookingForm.controls['first_name'].value.trim()) +
      (this.bookingForm.controls['last_name'].value?.trim()
        ? this.CommonService.replaceUnicode(this.bookingForm.controls['last_name'].value.trim())
        : '') +
      this.bookingForm.controls['mobile'].value
      ,
      "vehicle_application": "NA",
      "body_type": "NA",
      "usage_category": "",
      "vc_description": this.productDetailList["product_description"] ? this.productDetailList["product_description"] : "",
      "vc_number": this.productDetailList["vehicle_number"] ? this.productDetailList["vehicle_number"] : "",
      "ppl": this.productDetailList["ppl"] ? this.productDetailList["ppl"] : "",
      "vc_id": this.productDetailList["vehicle_id"] ? this.productDetailList["vehicle_id"] : "",
      "pl": this.productDetailList["pl"] ? this.productDetailList["pl"] : "",
      // "quantity": String(this.bookingForm.value.quantity),
      "quantity": String(this.bookingForm.value.quantity),
      "model": this.productDetailList["model"] ? this.productDetailList["model"] : "",
      "interested_in_exchange": "No",
      "brand": "",
      "registration_number": "",
      "pi_for_exchange": "",
      "chassis_number": "",
      "manufacture_year": "",
      "mileage": "",
      "action_type": this.divData?.[0]?.payment_details?.length == 0 ? "Unbilled" : "Billed",
      "down_payment": this.productDetailList["down_payment"],
      "payment_gateway_type": this.divData?.[0]?.payment_details?.length > 0 ? this.divData?.[0]?.payment_details[0]?.payment_gt_type : 'RAZORPAY',
      "channel": 'Fleet Verse',
      "finance_account_id": "1-39ERX-657",
      "finance": "SELF",
      "source": this.utm_source,
      "medium": this.utm_medium,
      "campaign": this.utm_campaign,
      "campaign_id": this.gclid,
      "lead_origin": 'Landing Page',
      "ex_showroom_price": Math.round(this.newVCPrice)
    };
    if ((data.organization_name)?.length > 50) {
      data['organization_name'] = this.CommonService.replaceUnicode(this.bookingForm.controls['first_name'].value.trim()).trim() +
        this.bookingForm.value.mobile;
    }
    if (data.organization_name?.length > 50) {
      data['organization_name'] = (this.CommonService.replaceUnicode(this.bookingForm.controls['last_name'].value.trim())).substring(0, 39) +
        this.bookingForm.value.mobile;
    }
    await this.sub.add(this.apiService.generateLead(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.reqID = response.data.lead_row_id
          if (isPlatformBrowser(this.platformId)) {
            var unxPayload = [
              {
               pid: (this.productDetailList.vehicle_number).toString(),
               variantId: this.productDetailList.vehicle_number, // Only if variant is present
               qty: String(this.bookingForm.value.quantity),
               price: (this.productDetailList.price_range).toString()
               }]

            unbxUrl.fireUnbxdOrder(unxPayload)

            this.cleverService.FormSubmitted('Form Submitted',
              data.state,
              data.district,
              data.division_id,
              data.quantity,
              this.productDetailList?.images[0]?.image_url,
              this.id,
              this.productDetailList?.model,
              window.location.href,
              this.productDetailList['sub_lob'],
              this.productDetailList['lob'],
              this.productDetailList['ppl'],
              this.productDetailList['price_range'],
              this.productDetailList['down_payment'])
          }
          this.showCongratulationMsg = true;

          this.response = response.data;
          this.toastrService.success(response.data.msg);
          this.tractionSuccess = true;
          this.spinner.hide();

        }
        else {
          if (isPlatformBrowser(this.platformId)) {


            this.cleverService.FormSubmitted('Form Submission Failed',
              data.state,
              data.district,
              data.division_id,
              data.quantity,
              this.productDetailList?.images[0]?.image_url,
              this.id,
              this.productDetailList?.model,
              window.location.href,
              this.productDetailList['sub_lob'],
              this.productDetailList['lob'],
              this.productDetailList['ppl'],
              this.productDetailList['price_range'],
              this.productDetailList['down_payment'])
          }
          this.showCongratulationMsg = true;

          this.tractionfailed = true;

          this.spinner.hide();
          if (response.data.msg == 'Oops! You already have active request against this vehicle. Please visit My Booking Request section in Profile to complete the process.') {
            this.errormsg = {
              head: 'Duplicate Request',
              desc: 'Oops! You already have active request against this vehicle.'
            }
          } else {

            this.errormsg = {
              head: 'Request Failed',
              desc: response.data.msg
            }
          }
          // this.toastrService.warning(response.data.msg);
        }
      },
      error: () => {
        this.spinner.hide();

      },
      complete: () => {
        this.spinner.hide();

      }
    }));
  }

  getNumber() {
    this.showotp = false;
  }

  verify() {
    this.spinner.show();
    if (this.bookingForm.value.otp?.length == 0 || this.bookingForm.value.otp?.length < 6) {
      this.spinner.hide();

      this.toastrService.warning('Please enter OTP');
      return;
    }
    this.hideproceedbtn = true;
    let data = { mobile_number: this.bookingForm.value.mobile, otp_number: this.bookingForm.value.otp };
    this.spinner.show();
    this.sub.add(
      this.apiService.userLogin(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.storageService.loginUser(response.data);
            this.spinner.show();
            this.createLead();

          } else {
            this.toastrService.warning(response.data.msg);
            this.spinner.hide();
            this.hideproceedbtn = false;
          }
        },
        error: () => {
          this.hideproceedbtn = false;
          this.spinner.hide();
          this.toastrService.warning(
            'Your account is locked due to multiple incorrect OTP. Please try after sometime'
          );
        },
        complete: () => {
        },
      })
    );
  }

  resetForm(value: any) {

    this.bookingForm.controls[value].setValue('');
    this.bookingForm.get(value).updateValueAndValidity();

  }

  startTimer(timeLeft: any) {
    this.timeLeft = timeLeft;
    const interval = setInterval(() => {
      this.isTimer = true;
      this.m = Math.floor(this.timeLeft / 60);
      this.s = this.timeLeft % 60;
      this.m = this.m < 10 ? '0' + this.m : this.m;
      this.s = this.s < 10 ? '0' + this.s : this.s;
      this.timeLeft--;
      if (this.timeLeft < 0) {
        this.isTimer = false;
        this.disabledFields = false;
        clearInterval(interval);
      }
    }, 1000);
  }


  getLeadDetail() {
    let data;
    data = {
      // request_id: this.encData.row_id
      request_id: this.encData
    }
    this.sub.add(this.apiService.getLeadsbyrefid(data).subscribe({
      next: (res: any) => {


        if (res.success) {
          this.LeadDetailList = res?.data;
          if (isPlatformBrowser(this.platformId)) {
          this.localStorage.setItem("accessTokenSILead", JSON.stringify(res?.data.user.token.token.access_token));
          }

          this.leadData = this.LeadDetailList?.leads[0];
          this.userData = this.LeadDetailList?.user
          let vehicleData = this.LeadDetailList?.leads[0].vehicle_info

          let image = vehicleData["images"] ? vehicleData["images"] : vehicleData["image"] ? vehicleData["image"] : vehicleData["images"]
          if (image) {
            if (image?.image_url) {
              this.imageUrl = image.image_url;
            } else {
              image.filter((image1: any) => image1.is_cover === true)
                .map((img: any) => {
                  this.imageUrl = img["image_url"];
                });
            }
          }


        }
      },
      error: () => {
        this.toastrService.success('Lead is not found');
      },
      complete: () => {
        if (this.encData) {

          this.getDistrictList(this.LeadDetailList?.leads[0]?.state, this.LeadDetailList?.leads[0]?.state_code);
          this.getDealerList(this.LeadDetailList?.leads[0]?.state, this.LeadDetailList?.leads[0]?.state_code, this.LeadDetailList?.leads[0]?.district);
        }
      }
    }))
  }

  payWithRazor(orderDetails: any, leadInfo: any, vehicleData: any) {


    const ResponseData: PaymentResponse = {} as PaymentResponse;
    const options: any = {
      key: orderDetails.razorpay_access_key,
      amount: orderDetails.pay_amount,
      currency: "INR",
      name: orderDetails.product_name, //'VSS', // company name or product name
      description: orderDetails?.product_description ? orderDetails?.product_description : "", //'Star City Bus',  // product description
      image: "assets/images/tata-logo.png", // company logo or product image
      order_id: orderDetails.order_id, // order_id created by you in backend
      account_id: orderDetails.razorpay_account_id,
      prefill: {
        email: orderDetails.email,
        contact: orderDetails.contact,
      },
      modal: {
        escape: false,
      },
      notes: {
        shopping_order_id: orderDetails.shopping_order_id,
      },
      theme: {
        color: "#0c238a",
      },
    };
    options.handler = (response: any) => {
      this.payMessage =
        "Your payment of ₹" +
        ((orderDetails.pay_amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- received against Request ID " +
        orderDetails.shopping_order_id +
        ".";
      options.response = response;
      ResponseData.razorpay_payment_id = response.razorpay_payment_id;
      ResponseData.razorpay_order_id = response.razorpay_order_id;
      ResponseData.razorpay_signature = response.razorpay_signature;
      this.sub.add(this.apiService.getPaymentDetail(ResponseData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.reqID = response.data.lead_row_id

            const objthank: ThankuResponse = {} as ThankuResponse;
            objthank.headMessage = "Thank You !";
            objthank.payMessage = this.payMessage;
            objthank.Image = this.imageUrl;
            objthank.vehicleID = vehicleData["id"] ? vehicleData["id"] : vehicleData["product_id"] ? vehicleData["product_id"] : vehicleData["id"]
            objthank.vehicleModel = vehicleData["model"];
            // objthank.orderAmount = response["data"].payment_amount / 100
            objthank.leadInfo = leadInfo;


            objthank.orderId = this.orderID;
            objthank.reqId = leadInfo.row_id;
            objthank.transactionStatus = 'success';
            if (isPlatformBrowser(this.platformId)) {
              objthank.productUrl = window.location.href;
            }
            objthank.payment_gateway = "RAZORPAY";
if (isPlatformBrowser(this.platformId)) {
            this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
}
            this.clevertapPayementcompFailed(leadInfo.booking_amount, leadInfo.quantity);

            this.showCongratulationMsg = true;

            this.tractionSuccess = true;
if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem("accessTokenSILead")
}
          } else {
            this.payMessage =
              "Your payment against Request ID " +
              orderDetails.shopping_order_id +
              " of ₹" +

              ((orderDetails.pay_amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
              "/- is not received.";
            this.clevertapPayementFailed(leadInfo.booking_amount, leadInfo.quantity);
            // this.transactionfailed = true;
            this.errormsg = {
              head: 'Sorry !',
              desc: this.payMessage
            }
            this.showCongratulationMsg = true;
            this.tractionfailed = true;
            if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem("accessTokenSILead")
            }
          }
        },
        error: () => { },
        complete: () => {
        }
      }))

    };
    options.modal.ondismiss = () => {
      this.payMessage =
        "Your payment against Request ID " +
        orderDetails.shopping_order_id +
        " of ₹" +

        ((orderDetails.pay_amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- is not received.";
      // this.isVerifyOtp = true;
      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = "Sorry !";
      objthank.payMessage = this.payMessage;
      objthank.Image = this.imageUrl;
      objthank.vehicleID = vehicleData["id"];
      objthank.leadInfo = leadInfo;
      objthank.reqId = leadInfo.row_id;
      objthank.vehicleModel = vehicleData["model"];
      // objthank.orderAmount = orderDetails.payment_amount / 100;
      objthank.payment_gateway = "RAZORPAY";
if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
}
      const ResponseDatas: PaymentResponse = {} as PaymentResponse;
      ResponseDatas.razorpay_order_id = orderDetails.order_id;
      this.sub.add(this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.errormsg = {
              head: 'Sorry !',
              desc: this.payMessage
            }
            this.showCongratulationMsg = true;
            this.tractionfailed = true;
            if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem("accessTokenSILead")
            }

          } else {
            this.clevertapPayementFailed(leadInfo.booking_amount, leadInfo.quantity);
            this.errormsg = {
              head: 'Sorry !',
              desc: this.payMessage
            }
            this.showCongratulationMsg = true;

            this.tractionfailed = true;
            if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem("accessTokenSILead")
            }

          }
        }
      }));
    };
     if (isPlatformBrowser(this.platformId)) {
    const rzp = new this.nativeWindow.Razorpay(options);
    rzp.open();
     }
    return ResponseData;
  }
  get nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    }
  }
  formatMoney(amount: any, decimalCount = 2, decimal = ".", thousands = ",") {
    // if (isPlatformBrowser(this.platformId)) {
    try {
      let i: any;
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? "-" : "";
      i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
      let j = i?.length > 3 ? i?.length % 3 : 0;
      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
          : ""));
    } catch (e) {

    }
    // }
  }
  clevertapPayementcompFailed(amount, quantity) {
    if (isPlatformBrowser(this.platformId)) {

      try {
        this.cleverService.onPaymentCompleted(
          "Success",
          "Online Transfer",
          this.productDetailList["id"],
          this.productDetailList["model"],
          this.imageUrl,
          "Top Navigation",
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
          this.productDetailList['down_payment'],
          amount * quantity,
        );
      } catch { }
    }
  }
  clevertapPayementFailed(amount, quantity) {

    if (isPlatformBrowser(this.platformId)) {

      try {
        this.cleverService.onPaymentfailed(
          this.productDetailList["id"],
          "Online Transfer",
          this.imageUrl,
          this.productDetailList["model"],
          "Top Navigation",
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
          this.productDetailList['down_payment'],
          amount * quantity,
        );
      } catch { }
    }
  }

  payWithCcavenu(formGroup: FormGroup) {
    const myform = document.createElement("form");
    myform.method = "POST";
    myform.action = this.ccavenue.baseurl;
    let input: any;
    for (const [key, value] of Object.entries(formGroup.value)) {
      input = document.createElement("input");
      input.name = key;
      input.id = key;
      input.value = value;
      myform.appendChild(input);
    }
    myform.style.display = "none";
    myform.append("Content-Type", "application/x-www-form-urlencoded");
    myform.append(
      "Accept",
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8"
    );
    document.body.appendChild(myform);
    myform.submit();
  }

  getEncryptionccavenue() {
    let req = {
      "type": "ccavenue",
      "filter": environment.ccavenueType
    }
    try {
      this.sub.add(this.apiService.getCCEncDetail(req).subscribe({
        next: (res: any) => {

          if (res.success) {
            if (isPlatformBrowser(this.platformId)) {

              let decrypt = this.localStorage.decryptData(res.data);
              this.ccavenue = JSON.parse(decrypt.replaceAll(`'`, `"`));
            }
          }
        },
        error: () => {
        },
        complete: () => {
        }
      }))
    } catch (error) {
    }

  }

  getCcAvenueEncryptionKey(leadInfo: any, ccavenueDetail, vehicleData) {

    let subAccId: string = "";
    subAccId = ccavenueDetail;

    let finalAmount = leadInfo.leads[0].vehicle_info.down_payment * leadInfo.leads[0].quantity
    finalAmount = Number(finalAmount)

    let data = {
      "data": {
        "amount": Number(finalAmount),
        "billing_address": "",
        "billing_city": "",
        "billing_email": "",
        "billing_country": "India",
        "billing_name": this.CommonService.replaceUnicode(leadInfo?.user?.first_name) + " " + this.CommonService.replaceUnicode(leadInfo?.user?.last_name),
        "billing_state": leadInfo?.user?.state,
        "billing_tel": leadInfo?.user?.mobile_number,
        "billing_zip": "",
        "cancel_url": this.ccavenue.redirectURL,
        "currency": "INR",
        "customer_identifier": "",
        "delivery_address": "",
        "delivery_city": "",
        "delivery_country": "India",
        "delivery_name": this.CommonService.replaceUnicode(leadInfo?.user?.first_name) + " " + this.CommonService.replaceUnicode(leadInfo?.user?.last_name),
        "delivery_state": leadInfo?.user?.state,
        "delivery_tel": leadInfo?.user?.mobile_number,
        "delivery_zip": "",
        "language": "EN",
        "merchant_id": this.ccavenue.merchant_id,
        "order_id": leadInfo.leads[0].payment_info.razorpay_order_id,
        "promo_code": "",
        // "sub_account_id":subAccId,
        "merchant_param1": "micro_lead",
        "redirect_url": this.ccavenue.redirectURL
      },

      working_key: this.ccavenue.workingKey,
    };

    data.data["sub_account_id"] = subAccId


    this.payMessage =
      "Your payment of ₹" +
      this.formatMoney(finalAmount) +
      "/-";
    const objthank: ThankuResponse = {} as ThankuResponse;
    objthank.headMessage = "Thank You !";
    objthank.payMessage = this.payMessage;
    objthank.Image = this.imageUrl;
    // objthank.orderId = response["data"].payment_order_id;
    objthank.orderId = this.orderID;

    objthank.leadInfo = leadInfo;
    objthank.reqId = leadInfo.leads[0].row_id;
    objthank.vehicleID = vehicleData["id"] ? vehicleData["id"] : vehicleData["product_id"] ? vehicleData["product_id"] : vehicleData["id"]

    objthank.vehicleModel = vehicleData["model"];
    objthank.orderAmount = finalAmount;
    if (isPlatformBrowser(this.platformId)) {
      objthank.productUrl = window.location.href;
    }
    // objthank.payment_gateway = orderDetails["payment_gateway_type"]
    objthank.payment_gateway = "CCAVENUE"
    if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
    }
    this.sub.add(this.apiService.getCCEncTokenDetail(data).subscribe({
      next: (res: any) => {
        if (res.success) {

          let encRequest = res.data;
          let ccavenuForm: FormGroup = this.formBuilder.group({
            encRequest: [encRequest],
            access_code: [this.ccavenue.accessCode],
          });
          this.payWithCcavenu(ccavenuForm);
        } else {
          this.toastrService.warning("Payment Aborted");
        }
      }
    })
    );
  }
  sanitizeInput(input: string): string {
    // Remove HTML tags
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }

  // Usage in the HTML
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = this.sanitizeInput(inputElement.value);
  }
  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.bookingForm);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);
  public hasMaxLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);

  public hasMinLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);


  get f(): { [key: string]: AbstractControl } {
    return this.bookingForm.controls;
  }
  nAllowSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
}
export class PaymentResponse {
  razorpay_payment_id: string = '';
  razorpay_order_id: string = '';
  razorpay_signature: string = '';
}



